import React, { useEffect } from 'react';

import { Box, makeStyles } from '@material-ui/core';
import NProgress from 'nprogress';

import SymbolLoading from 'components/common/SymbolLoading';

import { TOP_BAR_HEIGHT } from '../TopBar/constants';

const useStyles = makeStyles(theme => ({
  root: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    minHeight: `calc(100vh - ${TOP_BAR_HEIGHT}px)`,
    padding: theme.spacing(3),
  },
}));

function LoadingScreen(props) {
  const classes = useStyles();

  useEffect(() => {
    NProgress.start();

    return () => {
      NProgress.done();
    };
  }, []);

  return (
    <div className={classes.root}>
      <Box display="flex" justifyContent="center" p={2} {...props}>
        <SymbolLoading size={140} />
      </Box>
    </div>
  );
}

export default LoadingScreen;
